<template>
  <div class="col">
    <v-row align="center" justify="center" class="my-5">
      <v-img
        :src="require('@assets/logo/Logo_SemFundo_Agrosim_reduzido_restricted.png')" alt="AgroSim"
        max-width="300"
        class=""
        contain
      />
    </v-row>
    <v-row align="center" justify="center">
      <div>
        Olá, Cliente Agrosim. A página que você acessou é restrita. Assim, apenas usuários com permissões especiais podem acessar. 
      </div>
    </v-row>
    <v-row align="center" justify="center">
      <div>
        <v-btn 
          class="mt-4" 
          color="success"
          @click="goBack">
          <v-icon left>mdi-arrow-left</v-icon> 
          Voltar para a página anterior
        </v-btn>
      </div>
      <!-- <v-col cols="12">
        
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
  }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  },
}

</script>

<style scoped>

</style>
